import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from "../../../../constants";
import { formatNumericUSDate } from "../../../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
const ViewInvoice = _ref => {
  let {
    relationshipID,
    date,
    testId
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    as: Link,
    to: "".concat(routes.billingHub(relationshipID), "?selectedDate=").concat(formatNumericUSDate(date)),
    testId: testId,
    variant: "paragraph1",
    noWrap: true,
    ellipsis: true,
    children: "View Invoice"
  });
};
export default ViewInvoice;